export enum SnackbarTypes {
  error,
  warning,
  success,
  info,
}

export interface SnackbarState {
  type: SnackbarTypes;
  message: string;
  open: boolean;
}
